import { Icon } from '@chakra-ui/react';

export const TrashIcon = (props: any) => (
  <Icon aria-label="trash icon" color="secondary.400" {...props}>
    <path
      d="m6.86223841 20h10.27552319l.7142857-10h-11.70409461zm13.13776159-12-1 14h-14l-1-14zm-10 2h-2v10h2zm6 0h-2v10h2zm-3 0h-2v10h2zm2-8v3h5v2h-16v-2h5v-3zm-2 2h-2v1h2z"
      fill="currentColor"
    />
  </Icon>
);
